// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__3FfdA","admin":"Container_admin__1VGfd"};